module.exports = __webpack_public_path__ + "img/Narabi_logo_430x132px_RGB.80849ccf.png";